const waterVideo = document.querySelector('.su-water-photo video');
const waterToggle = document.querySelector('.su-video-toggle');

if (waterVideo && waterToggle) {
  const updateToggle = () => {
    const paused = waterVideo.paused;
    waterToggle.textContent = paused ? 'Play' : 'Pause';
    waterToggle.setAttribute('aria-label', paused ? 'Play water video' : 'Pause water video');
  };

  waterToggle.addEventListener('click', () => {
    if (waterVideo.paused) waterVideo.play().catch(updateToggle);
    else waterVideo.pause();
  });
  waterVideo.addEventListener('play', updateToggle);
  waterVideo.addEventListener('pause', updateToggle);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) waterVideo.pause();
  updateToggle();
}
